import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEmptyState, SpecraEntityCell, SpecraKeyValueRow, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { monthYear } from './vehicleUi';
export function PricingSheetsKept({ sheets }) {
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Pricing sheets · every generation kept"
            }),
            sheets.length === 0 && /*#__PURE__*/ _jsx(SpecraEmptyState, {
                size: "compact",
                title: "No pricing sheets on this vehicle yet."
            }),
            sheets.map((sheet)=>{
                const pending = sheet.pendingPeriodDecisions + sheet.pendingBurdenDecisions;
                const status = pending > 0 ? `${pending} to review` : ({
                    COMMITTED: 'Parsed',
                    HISTORY: 'History',
                    IN_REVIEW: 'In review',
                    REJECTED: 'Rejected',
                    CANCELLED: 'Cancelled'
                })[sheet.status] ?? 'Status unknown';
                const title = sheet.title || 'Pricing sheet';
                const row = /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-testid": Testids.registryVehicle.sheetRow,
                    label: /*#__PURE__*/ _jsx(SpecraEntityCell, {
                        title: title,
                        description: `${sheet.rowCountForCompany} observations · ${sheet.issuerKind === 'GOVERNMENT' ? 'Government-issued' : 'Company-issued'}`
                    }),
                    value: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(SpecraBadge, {
                                variant: pending > 0 || sheet.status === 'IN_REVIEW' ? 'warning' : sheet.status === 'COMMITTED' ? 'success' : 'neutral',
                                children: status
                            }),
                            /*#__PURE__*/ _jsxs(SpecraText, {
                                as: "p",
                                size: "meta",
                                tone: "muted",
                                children: [
                                    "Generation ",
                                    sheet.generation,
                                    sheet.uploadedAt && ` · ${monthYear(sheet.uploadedAt)}`
                                ]
                            })
                        ]
                    })
                }, sheet.generationId);
                return sheet.changeSetId ? /*#__PURE__*/ _jsx(SpecraLink, {
                    className: "block",
                    renderLink: renderRouterLink,
                    href: `/registries/pricing-sheets/${encodeURIComponent(sheet.changeSetId)}`,
                    "aria-label": title,
                    children: row
                }, sheet.generationId) : row;
            })
        ]
    });
}
